import { Component, inject } from '@angular/core';
import { DxButtonComponent } from 'devextreme-angular';
import { NavigatorService } from 'src/app/shared/services/navigator.service';

@Component({
  selector: 'app-btn-nuova-consegna',
  templateUrl: './btn-nuova-consegna.component.html',
  styleUrls: ['./btn-nuova-consegna.component.scss'],
  imports: [DxButtonComponent],
  standalone: true
})
export class BtnNuovaConsegnaComponent {

  private navService = inject(NavigatorService);

  goToConsegnaNew() {
    this.navService.goToNuovaConsegna();
  }

}

